export default "/images/sols.png";